import {
  Container,
  Text,
} from '@chakra-ui/react';
import MainLayout from '@src/components/layouts/main';
import LoadingSpinner from '@src/components/shared/LoadingSpinner';
import EmptyState from '@src/components/shared/EmptyState';
import Pagination from './Pagination';

export default function ReportContainer({
  title, isLoading, noData, downloadButton, moreInfo, children, error,
}) {
  const errorStatus = error?.response?.status;
  return (
    <MainLayout>
      <Container
        maxW="full"
        display="flex"
        flexDir="column"
        minHeight="100%"
      >
        <Pagination
          isLoading={isLoading}
          reportName={title}
          downloadButton={downloadButton}
          moreInfo={moreInfo}
        />
        {isLoading && <LoadingSpinner />}
        {!isLoading && !noData && !errorStatus && children}
        {!isLoading && noData && !errorStatus && (
          <EmptyState title="No Data" message="Sorry, there is no data available for the selected RCA or lockyear" />
        )}
        {(errorStatus === 401 || errorStatus === 403) && (
          <EmptyState
            title="Access Denied"
            message={(
              <>
                <Text color="gray.400">You do not have permission to view this page.</Text>
                <Text color="gray.400">Please sign in or select a different RCA.</Text>
              </>
        )}
          />
        )}
        {errorStatus === 500 && (
          <EmptyState
            title="Server Error"
            message="Sorry, there was an error processing your request. Please try again later."
          />
        )}
      </Container>
    </MainLayout>
  );
}
